module.exports = __webpack_public_path__ + "static/media/flight1.7d7e183f.png";